// extracted by mini-css-extract-plugin
export default {"loading":"CallDetail_loading__RsMli","fullHeight":"CallDetail_fullHeight__nneN+","fullWidth":"CallDetail_fullWidth__AU3uO","sentiment":"CallDetail_sentiment__mJ93O"};